import { useRouter } from 'next/router'

export const useDomainFromRouter = () => {
  const router = useRouter()
  return typeof router.query.domain === 'string'
    ? router.query.domain
    : undefined
}
